import { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAuthLoading, setAuthLoading] = useState(true);
    const [isLoginProcessing, setLoginProcessing] = useState(false);

    useEffect(() => {
        const initializeAuth = async () => {
            const token = localStorage.getItem('token') || sessionStorage.getItem('token');

            if (token) {
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                
                try {
                    // Verifica el usuario en el backend
                    const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/auth/validate`);
                    setUser(data); // Guardamos los datos completos del usuario
                } catch (error) {
                    console.error('Error al validar el token:', error);
                    logout();
                }
            } 

            setAuthLoading(false);
        };

        initializeAuth();
    }, []);

    const login = async (email, password, rememberMe) => {
        try {
            setLoginProcessing(true);
            const { data } = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/auth/login`, { email, password });
            const storage = rememberMe ? localStorage : sessionStorage;
            storage.setItem('token', data.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;

            setUser(data.user); // Ahora guardamos los datos completos del usuario

            setTimeout(() => {
                window.location.replace("/admin");
            }, 500);

            return true;
        } catch (error) {
            console.error('Error durante el login:', error);
            throw new Error(error.response?.data?.message || 'Login fallido');
        } finally {
            setLoginProcessing(false);
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        sessionStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, isAuthLoading, isLoginProcessing, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
